:host {
  --uui-dialog-font-family: var(--uui-primary-font-family);
  --uui-dialog-width: 600px;
  --uui-dialog-min-width: 600px;
  --uui-dialog-max-width: 50%;
  --uui-dialog-spacing: var(--uui-small-spacing, 1.25rem);
  --uui-dialog-border: var(
    var(--uui-border-base, 1px solid var(--uui-gray-06, #e5eff0))
  );
  --uui-dialog-border-color: var(--uui-gray-06, #e5eff0);
  --uui-dialog-border-radius: var(--uui-border-radius-md, 0.5rem);
  --uui-dialog-body-border: var(--uui-dialog-border);
  --uui-dialog-background-color: var(--uui-gray-01, #46535e);
  --uui-dialog-background-opacity: var(--uui-opacity-lighter, 0.6);
  --uui-dialog-shadow: var(
    --uui-shadow-base,
    0px 2px 24px rgba(192, 192, 192, 0.5)
  );
}

dialog::backdrop {
  background: var(--uui-gray-01, #46535e);
  opacity: 0.6;
  backdrop-filter: blur(3px);
}

dialog {
  padding: 0;
  width: var(--uui-dialog-width);
  min-width: var(--uui-dialog-min-width);
  max-width: var(--uui-dialog-max-width);
  border: var(--uui-dialog-border);
  border-radius: var(--uui-dialog-border-radius);
  border-color: var(--uui-dialog-border-color);
  box-shadow: var(--uui-dialog-shadow);
}

dialog > div.dialog__header,
dialog > div.dialog__footer {
  padding: var(--uui-dialog-spacing);
}

.dialog__body {
  border-top: var(--uui-dialog-body-border);
  border-bottom: var(--uui-dialog-body-border);
  overflow: var(--uui-dialog-body-overflow);
  overflow-x: var(--uui-dialog-body-overflow-x, hidden);
  overflow-y: var(--uui-dialog-body-overflow-y);
  padding: var(--uui-dialog-body-padding, var(--uui-dialog-spacing));
}

.dialog__footer {
  padding-block: var(--uui-dialog-spacing);
}
